<template lang="html">
  <div class="container">
    <div class="no-content" v-if="!post.media_url">Resposta sem url da midia</div>
    <video controls v-if="post.media_url && post.media_type == 'VIDEO'">
      <source :src="post.media_url" >
    </video>
    <img :src="`${post.permalink}media`" v-if="post.permalink" />
    <img :src="post.media_url" v-else />
  </div>
</template>

<script>

export default {
  name: 'item-media',
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
video,
img {
  display: block;
  width: 100%;
}

.container {
  width: 100%;
  padding: 0;
  height: 100%;
  align-items: center;
  overflow: hidden;
  display: flex;
}

.no-content {
  min-width: 100%;
  height: 100%;
  border: 1px dashed #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
